import { render, staticRenderFns } from "./ChildCard.vue?vue&type=template&id=78f0feb1&scoped=true&"
import script from "./ChildCard.vue?vue&type=script&lang=js&"
export * from "./ChildCard.vue?vue&type=script&lang=js&"
import style0 from "./ChildCard.vue?vue&type=style&index=0&id=78f0feb1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f0feb1",
  null
  
)

export default component.exports